import {
  useMutation,
  UseMutationOptions,
  UseMutationResult,
} from '@tanstack/react-query';
import { MutationFetchFunction } from 'common/helpers/common';
import { ApiError, ApiResult } from 'common/repositories/common.model';

import {
  AgentModel,
  AgentMutationInput,
  AgentDeleteInput,
  AgentUpdateInput,
} from './model';

export function useCreateAgent(
  options?: UseMutationOptions<
    ApiResult<AgentModel>,
    ApiError,
    AgentMutationInput
  >,
): UseMutationResult<ApiResult<AgentModel>, ApiError, AgentMutationInput> {
  return useMutation<ApiResult<AgentModel>, ApiError, AgentMutationInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: 'agents',
        method: 'POST',
        classType: AgentModel,
        body,
      });
    },
    options,
  );
}

export function useUpdateAgent(
  options?: UseMutationOptions<
    ApiResult<AgentModel>,
    ApiError,
    AgentUpdateInput
  >,
): UseMutationResult<ApiResult<AgentModel>, ApiError, AgentUpdateInput> {
  return useMutation<ApiResult<AgentModel>, ApiError, AgentUpdateInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `agents/${body.agentId}`,
        method: 'PUT',
        classType: AgentModel,
        body: body.body,
      });
    },
    options,
  );
}

export function useDeleteAgent(
  options?: UseMutationOptions<{ message: string }, ApiError, AgentDeleteInput>,
): UseMutationResult<{ message: string }, ApiError, AgentDeleteInput> {
  return useMutation<{ message: string }, ApiError, AgentDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `agents/${body.agentId}`,
        method: 'DELETE',
      });
    },
    options,
  );
}

export function useSuspendAgent(
  options?: UseMutationOptions<{ message: string }, ApiError, AgentDeleteInput>,
): UseMutationResult<{ message: string }, ApiError, AgentDeleteInput> {
  return useMutation<{ message: string }, ApiError, AgentDeleteInput>(
    async function (body) {
      return await MutationFetchFunction({
        url: `agents/${body.agentId}/surveillance`,
        method: 'PATCH',
        body: body.body,
      });
    },
    options,
  );
}
